import img1 from './assets/img/grafika/225x225_01.png'
import img2 from './assets/img/grafika/225x225_02.png'
import img3 from './assets/img/grafika/225x225_03.png'
import img4 from './assets/img/grafika/225x225_04.png'
import img5 from './assets/img/grafika/SLO_225x225_05.png'
import img6 from './assets/img/grafika/225x225_06.png'

const boxes_landing_SI = [
    {
        id: 0,
        title: 'Priprava velikonočnega bruncha',
        subtitle: 'ZA VSAKOGAR NEKAJ',
        image: img1,
        description: 'Velika noč je – čas za brunch! Imamo odlične recepte za odličen brunch: trendovsko, za vsak okus in zelo privlačno na pogled.',
        link_text: 'Priprava velikonočnega bruncha: za vsakega se nekaj najde! | Dr. Oetker',
        link_url: 'https://www.oetker.si/si-si/velika-noc/zacetek/velikonocni-brunch'
    },
    {
        id: 1,
        title: 'Velikonočna potica in pletenica',
        subtitle: 'NAJ ŽIVI TRADICIJA',
        image: img2,
        description: 'Kako narediti popolno vzhajano testo? Pustite ga počivati!',
        link_text: 'Velikonočna potica in pletenica - Začetek | Dr. Oetker',
        link_url: 'https://www.oetker.si/si-si/velika-noc/zacetek/velikonocna-potica-in-pletenica'
    },
    {
        id: 2,
        title: 'Velikonočna okrasitev',
        subtitle: 'IDEJE ZA OKRAŠEVANJE',
        image: img3,
        description: 'Oglejte si naše ideje in nasvete za velikonočno okrasitev, ki bo polepšala trenutke z vašimi najdražjimi.',
        link_text: 'Velikonočno dekoriranje - Dekoriranje | Dr. Oetker',
        link_url: 'https://www.oetker.si/si-si/velika-noc/zacetek/dekoriranje/velikonocno-dekoriranje'
    },
    {
        id: 3,
        title: 'Nasveti za barvanje pirhov',
        subtitle: 'IDEJE ZA OKRAŠEVANJE',
        image: img4,
        description: 'Barvanje pirhov je zelo preprosto, zabavno pa je tako za otroke kot tudi za odrasle – prepričajte se sami!',
        link_text: 'Nasveti za barvanje pirhov - Začetek | Dr. Oetker',
        link_url: 'https://www.oetker.si/si-si/velika-noc/zacetek/nasveti-za-barvanje-pirhov'
    },
    {
        id: 4,
        title: 'Dr. Oetker spletna trgovina',
        subtitle: 'SHOP',
        image: img5,
        description: 'Poiščite velikonočno ponudbo v spletni trgovini Dr. Oetker!',
        link_text: 'Domov - Dr. Oetker web shop Slovenija (oetker-shop.si)',
        link_url: 'https://oetker-shop.si/'
    },
    {
        id: 5,
        title: 'Dr. Oetker newsletter',
        subtitle: 'NEWSLETTER',
        image: img6,
        description: 'Prijavite se na mesečne novice Dr. Oetkerja.',
        link_text: 'Newsletter - Dr. Oetker web shop Slovenija (oetker-shop.si)',
        link_url: 'https://oetker-shop.si/newsletter/'
    }
]

export default boxes_landing_SI